module.exports = __webpack_public_path__ + "static/media/classwork-completion-screen-bg.6eb3ad9f.png";